import { Reference, useMutation } from '@apollo/client';

import {
  CarePlanActionItemCreateDocument,
  CarePlanActionItemCreateMutation,
  CarePlanActionItemCreateMutationVariables,
  CarePlanActionItemFragmentDoc,
  GetJourneyWithPlanQuery,
  WorksheetFragmentDoc
} from '@typing/Generated';
import { getAllGoals } from '@utils/modelUtils';

const useCreateCarePlanActionItem = (journey: GetJourneyWithPlanQuery['journey']) => {
  const [createCarePlanActionItem] = useMutation<
    CarePlanActionItemCreateMutation,
    CarePlanActionItemCreateMutationVariables
  >(CarePlanActionItemCreateDocument, {
    update: (store, { data }) => {
      if (data?.carePlanActionItemCreate?.carePlanActionItem) {
        const goal = getAllGoals(journey).find(
          goal => data.carePlanActionItemCreate?.carePlanActionItem?.goal.id === goal.id
        );

        goal?.carePlanActionItems.map(ai => {
          store.modify({
            fields: {
              position() {
                return ai.position + 1;
              }
            },
            id: store.identify({ ...ai })
          });
        });

        const newActionItem = data.carePlanActionItemCreate.carePlanActionItem;

        if (newActionItem?.worksheet) {
          store.modify({
            fields: {
              worksheets(cachedWorksheetRefs: readonly Reference[]) {
                const newWorksheetRef = store.writeFragment({
                  data: newActionItem.worksheet,
                  fragment: WorksheetFragmentDoc,
                  fragmentName: 'Worksheet'
                });
                if (newWorksheetRef) {
                  return [...cachedWorksheetRefs, newWorksheetRef];
                }
                return [...cachedWorksheetRefs];
              }
            },
            id: store.identify({ ...journey })
          });
        }

        if (goal) {
          goal.carePlanActionItems.map(ai => {
            store.modify({
              fields: {
                position() {
                  return ai.position + 1;
                }
              },
              id: store.identify({ ...ai })
            });
          });
          store.modify({
            fields: {
              carePlanActionItems(cachedActionItemRefs: readonly Reference[]) {
                const newActionItemRef = store.writeFragment({
                  data: newActionItem,
                  fragment: CarePlanActionItemFragmentDoc,
                  fragmentName: 'CarePlanActionItem'
                });
                if (newActionItemRef) {
                  return [...cachedActionItemRefs, newActionItemRef];
                }
                return [...cachedActionItemRefs];
              }
            },
            id: store.identify({ ...goal })
          });
        }
      }
    }
  });

  return createCarePlanActionItem;
};

export default useCreateCarePlanActionItem;
